import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'

export const sshKeysSelector = createSharedSelector(
  getDataSelector<DataKeys.SshKeys>(DataKeys.SshKeys),
  (keys) => {
    return keys
  },
)
